'use client'

import type { ReactNode } from 'react'
import { SharedSurfaceProvider, type SharedSurface } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'
import { MsgDeskLoading } from '@/stdDesk/MsgDeskLoading'
import { sharedSkin } from './SharedSkin'

// Std wiring for the Shared-area skeleton: std supplies its loading widget
// (Layer C look component) and its skin through the seam.

const stdSharedSurface: SharedSurface = {
  Loading: MsgDeskLoading,
  skin: sharedSkin,
}

export function StdSharedSurfaceProvider({ children }: { children: ReactNode }) {
  return <SharedSurfaceProvider value={stdSharedSurface}>{children}</SharedSurfaceProvider>
}
